import axios from 'axios';

const api = axios.create({
    //baseURL: 'http://hopediagnostica.ar.srv.br:8282/servicos_arlab/api'
    baseURL: 'http://hopediagnostica.ar.srv.br:8282/servicos_arlab/api' /* quando publicado em produção  */
});

export default api;